<!--
 * @Author: QWX
 * @Description:详情页文件预览
 * @LastEditors: QWX
 * @LastEditTime: 2021-12-27 14:21:58
-->
<template>
  <div class="zs-file-preview">
    <transition-group tag="div" name="fileAnimation">
      <div v-for="(item, index) in fileList" :key="item.guid + index"  class="zs-file-item">
        <div class="zs-file-icon-box">
          <i class="el-icon-document"></i>
        </div>
        <div class="zl-file-msg">
          <div class="zl-file-box">
            <p class="zl-file-name" :title="item.name">{{item.name}}</p>
            <p class="zs-file-time">{{item.createTime | $zlFiltersDateFormat('yyyy-MM-dd')}}</p>
          </div>
          <div class="zs-file-tool">
            <el-button icon="el-icon-view" size="mini" v-if="canBeView(item.name) && isYuLan" :disabled="false" @click="preView(item)">预览</el-button>
            <el-button icon="iconfont icon-xiazai" size="mini" :disabled="false" @click="download(item.guid)">下载</el-button>
            <el-button icon="el-icon-delete" v-if="!isView" size="mini" class="deleteBtn" plain @click="handleDelete(index)">删除</el-button>
            <!-- <i class="el-icon-view" @click="preView(item)" v-if="canBeView(item.name)"></i>
              <i class="iconfont icon-xiazai" @click="download(item.guid)"></i>
              <i class="el-icon-delete" v-if="!isView" @click="handleDelete(index)"></i> -->
          </div>
          <!-- <div class="zs-file-time">{{item.createTime | $zlFiltersDateFormat('yyyy-MM-dd')}}</div> -->
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>

import preViewDialog from '@/components/dialog/preViewDialog'
import store from '@/store'
import { cloneDeep } from 'lodash-es'
import config from '@/config/config'
export default {
  name: 'zsFilePreview',
  props: {
    // v-model 绑定groupId
    value: {
      type: String,
      default: ''
    },
    fileList: {
      type: Array,
      default: () => []
    },
    isView: {
      type: Boolean,
      default: false
    },
    isYuLan: {
      type: Boolean,
      default: true
    }

  },
  watch: {
  },
  methods: {
    handleDelete(index) {
      let arr = cloneDeep(this.fileList)
      const deleteFile = arr.splice(index, 1)
      this.$emit('on-remove', deleteFile, arr)
    },
    preView(item) {
      this.$zl.dialog.openFull(preViewDialog, item)
    },
    /**
     * @description: 图片和 pdf能够预览
     * @param {*} name
     */
    canBeView(name) {
      // const fileType = name.split('.')[1]
      const fileType = name.substring(name.lastIndexOf('.') + 1)
      return ['pdf', 'PDF', 'png', 'jpg', 'gif', 'jpeg'].includes(fileType.toLocaleLowerCase())
    },
    async download(guid) {
      const result = await this._util.getFileToken(2, 1, guid)
      // 下载文件
      window.open(
        `${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${guid}&token=${result}`
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.zs-file-preview{
    width: 100%;
    max-width:740px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 22px;
    margin-bottom: 10px;
    .zs-file-item{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-radius: 4px;
        padding-right: 4px;
        transition: all 0.5s cubic-bezier(0.55, 0, 0.1, 1);
        &:hover{
            background-color: #F5F7FA;
            span{
              color: #5c8bf6;
            }
        }
        &+.zs-file-item{
          margin-top: 8px;
        }
    }

    .zl-file-name{
        display: inline-block;
        // width: calc(100% - 60px) ;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        vertical-align: middle;
        margin: 0;
    }
    .zs-file-icon-box{
        width: 44px;
        height: 44px;
        line-height: 44px;
        font-size: 18px;
        text-align: center;
        background: #3973FF;
        color: #fff;
        border-radius: 4px;
    }
    .zl-file-msg{
        display: flex;
        overflow: hidden;
        text-align: left;
        flex: 1;
        padding-left: 6px;
        align-items: center;
        // justify-content: space-between;
        .zl-file-box {
          flex: 1;
          max-width: 500px;
          margin-right: 16px;
        }
    }
    .zs-file-tool{
        font-size: 14px;
        float: right;
        i{
            cursor: pointer;
        }
        i+i{
            margin-left: 8px;
        }
        .deleteBtn {
          color:rgb(248, 78, 68);;
          border-color:rgb(248, 78, 68);
          &:hover {
            background-color:rgb(248, 78, 68);
            border-color:rgb(248, 78, 68);
            color: #fff;
          }
        }
        .el-button--mini {
          padding: 6px 10px;
        }
    }
    .zs-file-time{
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.25);
        color: rgba(0, 0, 0, 0.45);
        margin: 0;
        // line-height: 20px;
    }
}
.iconfont.icon-xiazai{
  font-size: 14px;
}
.fileAnimation-enter-active, .fileAnimation-leave-active {
  transition: all .5s ease-out !important;
}
.fileAnimation-enter, .fileAnimation-leave-to {
  transform: translateY(50%);
  opacity: 0;
}
</style>
